import React from 'react'
import ArtworkDescriptionConnector, {
  ConnectorProps as ArtworkDescriptionProps,
} from '../../../../connectors/ArtworkDescription'
import { CONTACT_US_LINK, HELP_SECTION_LINK } from '../../../../helpers/constants'
import styles from './ContactUs.module.scss'

const ContactUs = (props: ArtworkDescriptionProps) => {
  const { screenWidth } = props
  const targetValue = screenWidth > 1064 ? '_blank' : '_self'
  const relValue = screenWidth > 1064 ? 'noopener noreferrer' : ''

  return (
    <div className={styles.contactUsBox}>
      <p>Need more information?</p>
      <div className={styles.linksBox}>
        <a target={targetValue} rel={relValue} href={CONTACT_US_LINK} title='contact us'>
          Contact us.
        </a>
      </div>
    </div>
  )
}

export default ArtworkDescriptionConnector(ContactUs)
